import React, { useState } from 'react'
import styles from "../DashBoardLayout/styles/SideBar.module.css"
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import ListItemIcon from "@mui/material/ListItemIcon";
import AccountCircleRoundedIcon from '@mui/icons-material/AccountCircleRounded';
import AddTwoToneIcon from '@mui/icons-material/AddTwoTone';
import { FaRegCircleUser } from "react-icons/fa6";
import { TfiPieChart } from "react-icons/tfi";
import AssessmentIcon from '@mui/icons-material/Assessment';
import SummarizeIcon from '@mui/icons-material/Summarize';
import { IoLogOutOutline } from "react-icons/io5";
import { LuBuilding2 } from "react-icons/lu";
import TodayIcon from '@mui/icons-material/Today';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import LogoutIcon from '@mui/icons-material/Logout';
import { Collapse, Grid, colors } from "@mui/material";
import plus_img from "../../../src/images/plus.svg";
import minus_img from "../../../src/images/minus.svg";
import QueryStatsIcon from '@mui/icons-material/QueryStats';
import { useDispatch, useSelector } from 'react-redux';
import { setHandelNavBarState } from '../../reduxStore/reducer';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import DynamicFeedIcon from '@mui/icons-material/DynamicFeed';
const SideBar = (isOpen) => {
  const dispatch = useDispatch() 
  const navigate = useNavigate();
  // const { state } = useLocation();
  // console.log("State inside Sidebar---",state);
  const [moduleStatus, setModuleStatus] = useState({
    processingModule: false,
    reports: false,
    viewer: false,
  });
const[open,setOpen]= useState(false)
const[handelFun, setHandelFun] = useState(false)
const [selectedIndex, setSelectedIndex] = useState(0);
  const handleModuleState = (module) => {
    // console.log("ooooooo",module);
    setModuleStatus((prev) => {
      const newState = { ...prev };
      newState[module] = !newState[module];
      // console.log("newstarte", newState);
      return newState;
    });
  };
  const handleListItemClick = (event, index) => {
    setSelectedIndex(index);
  };
  const handelNavBar =(handelFun)=>{
    setHandelFun(!handelFun)
    console.log("handelFun inside", handelFun);
    dispatch(setHandelNavBarState(!handelFun))

  } 
  const navBarState = useSelector((state) => state.selectedDimensions.handelNavBarState)
    // const navigate = useNavigate()
  
      let reports=[
        {
          path: "/app/daily",
          img: <TodayIcon />,
          name: "Daily",
        },
        {
          path: "/app/weekly",
          img: <CalendarMonthIcon />,
          name: "Weekly",
        },
      ]
      
  return (
    
    <div className={styles.sidebar} onMouseEnter={()=>{handelNavBar(handelFun)}} onMouseLeave={()=>{handelNavBar(handelFun)}}>
    
      <div className={styles.sidebar_section}>
        <List>
          <ListItem
            // key={index}
            // component={NavLink}
            // to={text.path}
            className="secondary-nav-link"
            disablePadding
            sx={{
              display: "block",
              // marginRight: open ? "15px" : "10px",
              // paddingLeft: open ? "0px" : "7px",
            }}
          >
            <ListItemButton
            onClick={(event)=>{
              navigate('/app/profile')
            }}
              sx={{
                minHeight: 48,
                // justifyContent: open ? "center" : "center",
                // px: 1.9,
                paddingLeft: "1.5rem",
                "&:hover": {
                  backgroundColor: "#1C81C44D",
                },
              }}
            >

              <ListItemIcon
                sx={{
                  display: "block"
                }}
              >
                <AccountCircleRoundedIcon />
              </ListItemIcon>
              {
                navBarState ? (<ListItemText>Profile</ListItemText>):(<></>)
              }
             

            </ListItemButton>
            <ListItemButton
            onClick={(event)=>{
              navigate('/app/analytics')
            }}
              sx={{
                minHeight: 48,
                // justifyContent: open ? "center" : "center",
                // px: 1.9,
                paddingLeft: "1.5rem",
                "&:hover": {
                  backgroundColor: "#1C81C44D",
                },
              }}
            >

              <ListItemIcon
                sx={{
                  display: "block"
                }}
              >
                <QueryStatsIcon />
              </ListItemIcon>
              {
                navBarState ? (<ListItemText>Analytics</ListItemText>):(<></>)
              }
            </ListItemButton>
            <ListItemButton
              sx={{
                minHeight: 48,
                // justifyContent: open ? "center" : "center",
                // px: 1.9,
                paddingLeft: "1.5rem",
                "&:hover": {
                  backgroundColor: "#1C81C44D",
                },
              }}
              onClick={() => handleModuleState("processingModule")}
            >
              <ListItemIcon
                sx={{
                  display: "block"
                }}
              >
                <SummarizeIcon />
              </ListItemIcon>
              {
                navBarState ? (<ListItemText>Reports</ListItemText>):(<></>)
              }
              {/* {moduleStatus.processingModule ? (
                <img src={minus_img} alt="-" />
              ) : (
                <img src={plus_img} alt="+" />
              )} */}
            </ListItemButton>
            <Collapse
              in={moduleStatus.processingModule}
              timeout="auto"
              unmountOnExit
              sx={{ marginLeft: "1.3rem" }}
            >
              {reports.map((text, index) => (
                <ListItem
                  key={index}
                  component={NavLink}
                  to={text.path}
                  className="secondary-nav-link"
                  disablePadding
                  sx={{
                    display: "block",
                    marginRight: "0px",
                   paddingLeft: "1rem",
                  }}
                >
                  <ListItemButton
                    // selected={selectedIndex === index}
                    onClick={(event) => handleListItemClick(event, index)}
                    sx={{
                      minHeight: 48,
                      justifyContent: open ? "center" : "center",
                      px: 1.5,
                      "&:hover": {
                        backgroundColor: "#1C81C44D",

                        // borderLeft: '4px solid #00B1E2'
                      },
                      color:"#000"
                     
                    }}
                  >
                    <ListItemIcon
                      sx={{
                        minWidth: 0,
                        // mr:"0.01rem",
                        // justifyContent: 'center',
                      }}
                    >
                      {/* <img src={text.img} /> */}
                      {text.img}
                    </ListItemIcon>
                    {
                     navBarState ?( <ListItemText
                      primary={text.name}
                      // sx={{ opacity: open ? 0 : 1 }}
                      primaryTypographyProps={{ fontSize: "14px", ml: "1rem" }}
                    />) :(<></>)
                    }
                   
                    {/* <ListItemText  sx={{ opacity: open ? 0 : 1 }} primaryTypographyProps={{ style: text }} primary="MyText" /> */}
                    {/* {text.name} */}
                  </ListItemButton>
                </ListItem>
              ))}
            </Collapse>
             <ListItemButton
            onClick={(event)=>{
              navigate('/app/reportBuilder')
            }}
              sx={{
                minHeight: 48,
                // justifyContent: open ? "center" : "center",
                // px: 1.9,
                paddingLeft: "1.5rem",
                "&:hover": {
                  backgroundColor: "#1C81C44D",
                },
              }}
            >

              <ListItemIcon
                sx={{
                  display: "block",
                  // marginRight: !open ? "0px" : "-10px",
                  // paddingLeft:"7px",
                  paddingLeft: "0.2rem",
                }}
              >
                <DynamicFeedIcon />
              </ListItemIcon>
              {
                navBarState ? (<ListItemText>Report Builder</ListItemText>):(<></>)
              }

            </ListItemButton> 
            <ListItemButton
            onClick={(event)=>{
              navigate("/");
              localStorage.clear();
            }}
              sx={{
                minHeight: 48,
                // justifyContent: open ? "center" : "center",
                // px: 1.9,
                paddingLeft: "1.5rem",
                "&:hover": {
                  backgroundColor: "#1C81C44D",
                },
              }}
            >

              <ListItemIcon
                sx={{
                  display: "block"
                }}
              >
                <LogoutIcon />
              </ListItemIcon>
              {
                navBarState ? (<ListItemText>Logout</ListItemText>) :((<></>))
              }

            </ListItemButton>
          </ListItem>
          {/* <ListItem>
            <ListItemButton>
                 <ListItemIcon><IoLogOutOutline/></ListItemIcon>
                  <ListItemText>
                    hsgdhgd
                  </ListItemText>
            </ListItemButton>
          </ListItem> */}
       
        </List>
      </div>

    </div>
 
        
  );
  
}

export default SideBar